import {
  DocumentActionButton,
  DocumentListItem,
  DocumentListItemResponse,
} from '@/models/documents/document-list.model';
import { formatDateTimePassedUtil } from '@/utils/format-date-time-passed.util';
import { documentActionMap } from '@/constants/documents/document-list-column.constant';

export const documentListApiToDtoMapper = (documentListApi: DocumentListItemResponse): DocumentListItem => {
  const actionData: DocumentActionButton | null =
    documentListApi.documentModerationAction !== null
      ? documentActionMap[documentListApi.documentModerationAction]
      : null;

  return {
    ...documentListApi,
    lastPendingFileUploadedAt: formatDateTimePassedUtil(documentListApi.lastPendingFileUploadedAt) ?? '—',
    actionType: actionData?.type,
    actionLabel: actionData?.label,
  };
};
